import React, { useEffect, useState } from 'react';
import './SpecialEventList.scss';
import { FxSelect, FxDateDisplay, http, general, localstorage, formatService, FxCurrency, AlertService } from '../../fx-core';
import { Fab, Button, Paper, Table, TableBody, makeStyles, TableCell, TableContainer, TableHead, TableRow, Drawer, Dialog, Backdrop, CircularProgress } from '@material-ui/core';
import { NoRecords } from '../../NoRecords/NoRecords';
import SpecialEventEnrol from '../SpecialEventEnrol/SpecialEventEnrol';
import SpecialEventPayment from '../SpecialEventPayment/SpecialEventPayment';
import useRazorpay from '../../utils/useRazorPay';

const styles = makeStyles((theme) => ({
    drawerWidth: {
        [theme.breakpoints.down(599)]: { width: '90%' },
        [theme.breakpoints.up(600)]: { width: '70%' },
        [theme.breakpoints.up(1025)]: { width: '40%' }
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 9999,
        color: '#fff',
        flexDirection: 'column',
        gap: '16px'
    }
}));

const SpecialEventList = (props) => {
    const classes = styles();
    const Razorpay = useRazorpay();

    let defaultFilter = { stallId: -1 };
    let defaultEvent  = { serviceRequestId: 0, amount: 0, id: 0 };

    const [filters,          setFilters]          = useState(defaultFilter);
    const [stalls,           setStalls]           = useState([]);
    const [specialEventList, setSpecialEventList] = useState([]);
    const [enrolFormOpen,    setEnrolFormOpen]    = useState(false);
    const [selectedId,       setSelectedId]       = useState(0);
    const [paymentOpen,      setPaymentOpen]      = useState(false);
    const [selEvent,         setSelEvent]         = useState(defaultEvent);

    // ── Loading state for Razorpay processing ──────────────────────────────────
    const [razorpayLoading,  setRazorpayLoading]  = useState(false);
    const [loadingMsg,       setLoadingMsg]       = useState("Processing payment...");

    const handleInputChange = (item) => {
        handleFilterChange({ [item.name]: item.value });
        let filterObj = { stallId: filters.stallId };
        if (item.name == 'stallId') filterObj.stallId = item.value;
        getSpecialEventList(filterObj);
    };

    const handleFilterChange = (data) => {
        setFilters(prevState => ({ ...prevState, ...data }));
    };

    const initLookup = () => {
        let inputData = {
            lookups: { ProviderStalls: { default: true } },
            filters: {
                userId: localstorage.getItem('userId'),
                communityId: localstorage.getItem("communityId")
            }
        };
        http.post({ url: 'options/lookup', data: inputData }).then(response => {
            let result = response.data;
            setStalls(result.ProviderStalls);
        });
    };

    const getSpecialEventList = (data) => {
        http.post({
            url: `community/provider/special/events`,
            data: { stallId: data.stallId }
        }).then(res => {
            getSpecialEventListCallBack(res);
        });
    };

    const getSpecialEventListCallBack = (res) => {
        const result = res.data;

        for (let item of result) {
            item.profileImageUrl = general.getImageUrl(item.profileImagePath);
            const swapAmPm = (timeStr) => {
    if (!timeStr) return timeStr;
    if (timeStr.includes('AM')) return timeStr.replace('AM', 'PM');
    if (timeStr.includes('am')) return timeStr.replace('am', 'pm');
    if (timeStr.includes('PM')) return timeStr.replace('PM', 'AM');
    if (timeStr.includes('pm')) return timeStr.replace('pm', 'am');
    return timeStr;
};

item.startTime = item.startTime != null ? swapAmPm(formatService.getConvertedTimeForDisplay(item.startTime)) : null;
item.endTime   = item.endTime   != null ? swapAmPm(formatService.getConvertedTimeForDisplay(item.endTime))   : null;


            if (item.paymentMode == "accounttransfer") {
                item.paymentModeText = "Bank Transfer";
            } else if (item.paymentMode == "razorpay") {
                item.paymentModeText = "Cash/UPI";
            }

            // Compute finalAmount
            if (item.amount == 0) {
                item.finalAmount = 0;
            } else {
                const start = new Date(item.startDate);
                const end   = new Date(item.endDate);
                start.setHours(0,0,0,0);
                end.setHours(0,0,0,0);
                let diffDays = (end - start) / (1000 * 60 * 60 * 24);
                let totalDays = diffDays <= 1 ? 1 : diffDays;
                const baseAmount = item.amount * totalDays;
                item.finalAmount = (item.discountAmount > 0)
                    ? item.originalAmount - item.discountAmount
                    : baseAmount;
            }

            // Expired flag — use Date comparison to handle any date format from API
            if (item.endDate) {
                const endDateObj = new Date(item.endDate);
                endDateObj.setHours(23, 59, 59, 999);
                item.isExpired = endDateObj < new Date();
            } else {
                item.isExpired = false;
            }
        }

        setSpecialEventList(result);
    };

    const createOrViewSplEvent = (id) => {
        setSelectedId(id);
        setEnrolFormOpen(true);
    };

    const handleEnrolFormClose = () => {
        setEnrolFormOpen(false);
        setSelectedId(0);
        getSpecialEventList(filters);
    };

    const openEventPayment = (item) => {
        // Always open the payment modal fresh — even if razorpay was previously selected
        // This allows user to re-choose between bank transfer and card
        setSelEvent({
            ...item,
            // Strip previously saved paymentMode so modal opens fresh
            paymentMode: null
        });
        setPaymentOpen(true);
    };

    const closeEventPayment = (res) => {
        setPaymentOpen(false);

        if (res && res.id > 0) {
            // If full coupon applied, just refresh
            if (res.isFullCoupon || res.amount === 0) {
                getSpecialEventList(filters);
                return;
            }

            // If Razorpay selected, initiate payment
            if (res.paymentMode === "razorpay") {
                initiatePayment(res.id, res.amount);
            } else {
                // Bank transfer — just refresh list
                getSpecialEventList(filters);
            }
        } else {
            // Modal closed without action — refresh to get latest state
            getSpecialEventList(filters);
        }
    };

    const initiatePayment = (id, amount) => {
        setRazorpayLoading(true);
        setLoadingMsg("Fetching payment details...");

        http.post({
            url: `payment/GetPaymentLink`,
            data: { entityTypeId: 6, entityId: id, amount: amount }
        }).then(res => {
            setLoadingMsg("Opening payment gateway...");
            openPaymentLink(res, id);
        }).catch(() => {
            setRazorpayLoading(false);
            AlertService.showErrorMsg("Failed to initiate payment. Please try again.");
        });
    };

    const openPaymentLink = (resp: any, serviceRequestId: number) => {
        const item = resp.data.result;
        const { checkoutIdentifier, externalOrderId, amount, description, providerName, email, mobile } = item;

        const options: any = {
            amount,
            description,
            order_id: externalOrderId,
            handler: async function (response: any) {
                setLoadingMsg("Confirming your payment...");
                let data: any = {
                    Id: item.id,
                    ExternalPaymentId: response.razorpay_payment_id,
                    ExternalOrderId: externalOrderId
                };
                await updateRazorPaySuccess(data);
                setRazorpayLoading(false);
                AlertService.showSuccessMsg("Payment successful!");
                // Refresh from server to get updated paymentStatus
                getSpecialEventList(filters);
            },
            prefill: { name: providerName, email, contact: mobile },
            modal: {
                ondismiss: () => {
                    // User closed Razorpay modal without paying
                    setRazorpayLoading(false);
                    // Refresh list — paymentMode is already saved as razorpay on server
                    // so next time PAY is clicked, modal opens fresh (Bug 3 fix)
                    getSpecialEventList(filters);
                }
            }
        };

        const rzp1 = new Razorpay(options);
        rzp1.on("payment.failed", function (response: any) {
            console.log("payment failed:", response);
            setRazorpayLoading(false);
            AlertService.showErrorMsg("Payment failed. Please try again.");
            getSpecialEventList(filters);
        });

        // Hide loading overlay just before opening Razorpay
        setRazorpayLoading(false);
        rzp1.open();
    };

    const updateRazorPaySuccess = async (inputData) => {
        await http.post({ url: `payment/updatePaymentSuccess`, data: inputData });
    };

    useEffect(() => {
        initLookup();
        getSpecialEventList(filters);
    }, []);

    // ── Pay button visibility logic ────────────────────────────────────────────
    // Show Pay only when:
    // 1. Amount > 0
    // 2. Not yet paid
    // 3. Not expired
    // 4. Approved (statusId == 2) with no paymentMode yet, OR paymentMode == razorpay but not paid
    const showPayButton = (row) => {
        if (row.isExpired) return false;
        if (!row.amount || row.amount <= 0) return false;
        if (row.paymentStatus === 'paid' || row.paymentStatus === 'Paid') return false;

        // Fresh approval — no payment mode chosen yet
        if (row.serviceRequestStatusId == 2 && !row.paymentMode) return true;

        // Razorpay was selected but payment not completed
        if (row.paymentMode === 'razorpay' && row.paymentStatus !== 'paid' && row.paymentStatus !== 'Paid') return true;

        return false;
    };

    return (
        <div className='spleventlist-ui pt-5'>
            {/* ── Razorpay loading overlay ───────────────────────────────────── */}
            <Backdrop className={classes.backdrop} open={razorpayLoading}>
                <CircularProgress color="inherit" size={48} />
                <div style={{ fontSize: '1rem', fontWeight: 500, textAlign: 'center', maxWidth: 280 }}>
                    {loadingMsg}
                    <br />
                    <small style={{ opacity: 0.8, fontSize: '0.8rem' }}>
                        Please do not close or refresh this page.
                    </small>
                </div>
            </Backdrop>

            <div className='row title-font align-items-center justify-content-between pt-4 px-4'>
                <span className="col-8 pt-3 py-1 pl-4">
                    <span>Special Events</span>
                </span>
            </div>

            <div className="row col-12 my-3 ml-1 mr-5 justify-content-between">
                <div className="col-3">
                    <FxSelect name="stallId" variant="outlined" label="Stalls"
                        options={stalls}
                        selectedValue={filters.stallId}
                        valueField="id"
                        displayField="text"
                        size="small"
                        onValueChange={handleInputChange} />
                </div>
                <div className="col-3 pt-1 text-right">
                    <Fab variant="extended" size="medium" color="primary"
                        onClick={() => createOrViewSplEvent(0)}>
                        <i className="fas fa-plus pr-2"></i>
                        Add
                    </Fab>
                </div>
            </div>

            <div className='p-2 mx-3'>
                <div className='mb-4'>
                    <TableContainer component={Paper}>
                        <Table size="small" className='table-striped'>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Stall</TableCell>
                                    <TableCell>Community</TableCell>
                                    <TableCell>Start Date</TableCell>
                                    <TableCell>Start Time</TableCell>
                                    <TableCell>End Date</TableCell>
                                    <TableCell>End Time</TableCell>
                                    <TableCell>Event Status</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>Payment</TableCell>
                                    <TableCell>Action</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {specialEventList.length == 0 &&
                                    <TableCell colSpan={11}>
                                        <NoRecords />
                                    </TableCell>
                                }
                                {specialEventList.length > 0 && specialEventList.map((row: any, i) => (
                                    <TableRow key={row.serviceRequestId}>
                                        <TableCell>{row.stallName}</TableCell>
                                        <TableCell>{row.communityName}</TableCell>
                                        <TableCell>
                                            <FxDateDisplay value={row.startDate} />
                                        </TableCell>
                                        <TableCell>
                                            <i className="far fa-clock color-aaa px-1"></i>
                                            {row.startTime}
                                        </TableCell>
                                        <TableCell>
                                            <FxDateDisplay value={row.endDate} />
                                        </TableCell>
                                        <TableCell>
                                            <i className="far fa-clock color-aaa px-1"></i>
                                            {row.endTime}
                                        </TableCell>
                                        <TableCell>{row.eventStatus}</TableCell>
                                        <TableCell>
                                            {row.discountAmount > 0 ? (
                                                <span>
                                                    <span style={{ textDecoration: 'line-through', color: '#999', marginRight: 4, fontSize: '0.85em' }}>
                                                        <FxCurrency value={row.originalAmount} />
                                                    </span>
                                                    <span style={{ color: '#2e7d32', fontWeight: 600 }}>
                                                        <FxCurrency value={row.originalAmount - row.discountAmount} />
                                                    </span>
                                                </span>
                                            ) : (
                                                <FxCurrency value={row.finalAmount ?? row.amount} />
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {row.paymentStatus === 'paid' || row.paymentStatus === 'Paid'
                                                ? <span style={{ color: '#2e7d32', fontWeight: 600 }}>Paid</span>
                                                : 'Pending'
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <Button variant='outlined' size='small' className='button-style mr-2'
                                                onClick={() => createOrViewSplEvent(row.serviceRequestId)}>
                                                View
                                            </Button>
                                            {showPayButton(row) && (
                                                <Button variant='outlined' size='small' className='button-style mr-2'
                                                    onClick={() => openEventPayment(row)}>
                                                    Pay
                                                </Button>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {row.isExpired
                                                ? <span style={{ color: '#b71c1c' }}>Expired</span>
                                                : <span style={{ color: '#2e7d32' }}>Active</span>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

            <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }}
                open={enrolFormOpen} onClose={handleEnrolFormClose}>
                <SpecialEventEnrol id={selectedId} handleClose={handleEnrolFormClose} />
            </Drawer>

            <Dialog open={paymentOpen} maxWidth="sm" fullWidth
                onClose={() => closeEventPayment(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <SpecialEventPayment
                id={selEvent.serviceRequestId}
                communityId={selEvent.id}
                communityName={selEvent.communityName}
                stallName={selEvent.stallName}
                startDate={selEvent.startDate}
                endDate={selEvent.endDate}
                amount={selEvent.finalAmount ?? selEvent.amount}
                handleClose={closeEventPayment}
            />
            </Dialog>
        </div>
    );
};

export default SpecialEventList;